import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ProgressStepType {
  percentage: 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;
  label: string;
}

export enum ProgressStepEnum {
  CheckEligiblity = "CheckEligiblity",
  Profile = "Profile",
  Intro = "Intro",
  StartProgramme = "StartProgramme",
}

interface ProgressBarState {
  steps: Record<ProgressStepEnum, ProgressStepType>;
}

export type PowerOfTen = 0 | 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90 | 100;

interface ProgressToNextStepCommand {
  progressStepEnum: ProgressStepEnum;
  progressPercentage: PowerOfTen;
}

const initialState: ProgressBarState = {
  steps: {
    [ProgressStepEnum.CheckEligiblity]: {
      percentage: 0,
      label: "Check Eligibility",
    },
    [ProgressStepEnum.Profile]: {
      percentage: 0,
      label: "Your profile",
    },
    [ProgressStepEnum.Intro]: {
      percentage: 0,
      label: "Introducing gloji",
    },
    [ProgressStepEnum.StartProgramme]: {
      percentage: 0,
      label: "Start Programme",
    },
  },
};

const progressBarSlice = createSlice({
  name: "progressBar",
  initialState: initialState,
  reducers: {
    setStepProgress(state, action: PayloadAction<ProgressToNextStepCommand>) {
      const currentStep = state.steps[action.payload.progressStepEnum];

      currentStep.percentage = action.payload.progressPercentage;
      state.steps[action.payload.progressStepEnum] = currentStep;
    },
  },
});

export const { setStepProgress } = progressBarSlice.actions;
export default progressBarSlice.reducer;
